import { getEmployeeName } from "./employeeIdentity";
import OnboardingPageTitle from "./OnboardingPageTitle";
import { FormSelect } from "../../components/ui/select";
/* eslint-disable react-hooks/exhaustive-deps -- setBanner is a stable state wrapper */
import i18n from "../../i18n";
import { Trans } from "react-i18next";
import React, { useState, useCallback, useEffect } from 'react';
import './Addemployeepage.css';
// import { resolveApiUrl, resolveOrgApiUrl } from "../../shared/resolveApiUrl";
import { resolveApiUrl, resolveOrgApiUrl } from "../../api/api";
import sessionDB from "../../utils/sessionDB";
import {
  isOnboardingFeatureUnavailableError,
  isGenericOnboardingErrorMessage,
  isLookupRateLimitError,
  parseOnboardingErrorResponse,
  handleOnboardingApiError
} from
"./onboardingFeatureAccess";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue } from
"../../components/ui/select";
import { format } from "date-fns";
import { CalendarIcon } from "lucide-react";
import { Button } from "../../components/ui/button";
import { Calendar } from "../../components/ui/calendar";
import {
  Popover,
  PopoverContent,
  PopoverTrigger } from
"../../components/ui/popover";

const SERVICE_CODE = 'HR01A';
const API_ENDPOINT = '/saas/hrms/emp-info/add';
const STATES_ENDPOINT = '/saas/hrms/org/states';
// Reuse organization lookups across effect reruns and component remounts.
const orgLookupRequests = new Map();
const DISTRICTS_BY_STATE_ENDPOINT = '/saas/hrms/org/cities/by-state';

/* ─── Validation rules ─────────────────────────────────── */
function getFieldLabels() {
  return {
    firstName: i18n.t('onboarding.labels.firstName'),
    middleName: i18n.t('onboarding.labels.middleName'),
    lastName: i18n.t('onboarding.labels.lastName'),
    dateOfBirth: i18n.t('onboarding.labels.dateOfBirth'),
    email: i18n.t('common.email'),
    phone: i18n.t('onboarding.labels.phoneNumber'),
    contactType: i18n.t('onboarding.labels.contactType'),
    addressHouseNo: i18n.t('onboarding.labels.houseNo'),
    addressStreetName: i18n.t('onboarding.labels.streetName'),
    addressLocationArea: i18n.t('onboarding.labels.areaLocation'),
    addressDistrict: i18n.t('onboarding.labels.district'),
    addressState: i18n.t('onboarding.labels.state'),
    addressPincode: i18n.t('onboarding.labels.pincode'),
    addressDigipin: i18n.t('onboarding.labels.digipin'),
    addressGmapLink: i18n.t('onboarding.labels.googleMapsLink')
  };
}

function getRules() {
  return {
    firstName: (v) => !v.trim() ? i18n.t('onboarding.errors.firstNameRequired') : v.length > 100 ? i18n.t('onboarding.errors.max100Characters') : '',
    lastName: (v) => !v.trim() ? i18n.t('onboarding.errors.lastNameRequired') : v.length > 100 ? i18n.t('onboarding.errors.max100Characters') : '',
    middleName: (v) => v && v.length > 100 ? i18n.t('onboarding.errors.max100Characters') : '',
    dateOfBirth: (v) => v && new Date(v) >= new Date() ? i18n.t('onboarding.errors.mustBeInPast') : '',
    email: (v) => !v ? i18n.t('onboarding.errors.emailRequired') : !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) ? i18n.t('onboarding.errors.invalidEmail') : v.length > 150 ? i18n.t('onboarding.errors.max150Characters') : '',
    phone: (v) => !v.trim() ? i18n.t('onboarding.errors.phoneRequired') : !/^[0-9]{10,20}$/.test(v) ? i18n.t('onboarding.errors.digitsOnly10to20') : '',
    contactType: (v) => v && !['Phone', 'Email', 'Both'].includes(v) ? i18n.t('onboarding.errors.invalidContactType') : '',
    addressHouseNo: (v) => v && v.length > 50 ? i18n.t('onboarding.errors.max50Characters') : '',
    addressStreetName: (v) => v && v.length > 50 ? i18n.t('onboarding.errors.max50Characters') : '',
    addressLocationArea: (v) => v && v.length > 50 ? i18n.t('onboarding.errors.max50Characters') : '',
    addressDistrict: (v) => v && v.length > 50 ? i18n.t('onboarding.errors.max50Characters') : '',
    addressState: (v) => v && v.length > 50 ? i18n.t('onboarding.errors.max50Characters') : '',
    addressPincode: (v) => v && v.trim() && !/^[0-9]{6}$/.test(v) ? i18n.t('onboarding.errors.mustBe6Digits') : '',
    addressDigipin: (v) => v && v.length > 10 ? i18n.t('onboarding.errors.max10Characters') : '',
    addressGmapLink: (v) => ''
  };
}

const REQUIRED_FIELDS = ['firstName', 'lastName', 'email', 'phone'];

const INITIAL = {
  firstName: '', middleName: '', lastName: '', dateOfBirth: '',
  email: '', phone: '', contactType: '',
  addressHouseNo: '', addressStreetName: '', addressLocationArea: '',
  addressDistrict: '', addressState: '', addressPincode: '',
  addressDigipin: '', addressGmapLink: ''
};

function normalizeLookupOptions(payload, idKeys = [], labelKeys = []) {
  const candidates = [
  payload,
  payload?.data,
  payload?.content,
  payload?.result,
  payload?.data?.content,
  payload?.data?.result,
  payload?.data?.result?.content,
  payload?.records,
  payload?.items,
  payload?.rows,
  payload?.states,
  payload?.cities,
  payload?.districts,
  payload?.data?.states,
  payload?.data?.cities,
  payload?.data?.districts];


  const list = candidates.find((value) => Array.isArray(value));
  if (!Array.isArray(list)) return [];

  return list
  .map((item) => {
    if (!item || typeof item !== 'object') return null;
    const id = [
    ...idKeys.map((key) => item?.[key]),
    item?.stateId,
    item?.state_id,
    item?.cityId,
    item?.city_id,
    item?.districtId,
    item?.district_id,
    item?.id]
    .find((value) => value !== null && value !== undefined && String(value).trim());
    const label = [
    ...labelKeys.map((key) => item?.[key]),
    item?.stateName,
    item?.state_name,
    item?.cityName,
    item?.city_name,
    item?.districtName,
    item?.district_name,
    item?.name,
    item?.label]
    .find((value) => value !== null && value !== undefined && String(value).trim());

    if (!id || !label) return null;
    return { value: String(id).trim(), label: String(label).trim() };
  })
  .filter(Boolean);
}

/* ─── Field component ──────────────────────────────────── */
function Field({ id, label, required, error, children }) {
  return (
    <div className="aep-field">
      <label className={`aep-label${required ? ' required' : ''}`} htmlFor={id}>{label}</label>
      {children}
      <p className="aep-error" role="alert">{error || ''}</p>
    </div>);

}

/* ─── AddEmployeePage ──────────────────────────────────── */
export default function AddEmployeePage({
  accessToken,
  tenantCode,
  initialEmployeeId = "",
  onBack,
  onSuccess,
  onEmployeeIdentityChange,
  breadcrumb,
  isTabMode = false,
  isActive = true,
  onRateLimitError,
  saveTriggerRef
}) {
  useEffect(() => {
    if (saveTriggerRef) {
      saveTriggerRef.current = {
        submit: handleSubmit
      };
    }
  });
  const [form, setForm] = useState(INITIAL);
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});

  const [employeeIdentity, setEmployeeIdentity] = useState({ empId: "", name: "" });

  useEffect(() => {
    if (!employeeIdentity.empId || !employeeIdentity.name) return;
    sessionDB.updateSession({ onboardingEmployeeIdentity: employeeIdentity });
    onEmployeeIdentityChange?.(employeeIdentity);
  }, [employeeIdentity, onEmployeeIdentityChange]);

  const [loading, setLoading] = useState(false);
  const [banner, _setBanner] = useState(null); // { type: 'success'|'error', msg: string }

  // Derived — available both in event handlers and JSX
  const isEdit = !!initialEmployeeId;
  const reportLookupRateLimit = useCallback((message, status, errorBody) => {
    if (!isLookupRateLimitError(message, status, errorBody)) return false;
    if (typeof onRateLimitError === "function") {
      onRateLimitError();
    }
    return true;
  }, [onRateLimitError]);

  const setBanner = (val) => {
    _setBanner((prev) => {
      const next = typeof val === "function" ? val(prev) : val;
      if (next && next.type === "error") {
        if (reportLookupRateLimit(next.msg)) {
          return prev;
        }
        if (isOnboardingFeatureUnavailableError(next.msg)) {
          return { type: "error", msg: i18n.t("onboarding.featureUnavailable") };
        }
        if (isGenericOnboardingErrorMessage(next.msg)) {
          return prev;
        }
      }
      return next;
    });
  };
  const [stateOptions, setStateOptions] = useState([]);
  const [districtOptions, setDistrictOptions] = useState([]);
  const [statesLoading, setStatesLoading] = useState(false);
  const [districtsLoading, setDistrictsLoading] = useState(false);
  const [selectedStateId, setSelectedStateId] = useState('');
  const [selectedDistrictId, setSelectedDistrictId] = useState('');
  const tenantId = sessionDB.getTenantId() || '';
  const sessionAccessToken = sessionDB.getAccessToken() || accessToken || '';
  const tenantCodeFromSession = sessionDB.getTenantCode() || tenantCode || '';

  const fetchInfo = useCallback(async () => {
    if (!initialEmployeeId) return;
    try {
      const searchHeaders = {
        'x-tenant-code': tenantCodeFromSession || '',
        'x-tenant-id': String(tenantId || ''),
        'x-service-code': 'HR01S',
        'authorization': `Bearer ${sessionAccessToken}`
      };
      const response = await fetch(
        resolveApiUrl(`/saas/hrms/emp-info/search/${initialEmployeeId}`),
        { method: 'GET', headers: searchHeaders }
      );
      if (!response.ok) return;

      const body = await response.json();
      const candidates = [
      body?.data?.content?.[0],
      body?.data?.records?.[0],
      body?.data?.data?.[0],
      body?.data?.[0],
      body?.content?.[0],
      body?.data?.data,
      body?.data,
      body];

      // Prefer a real employee master record over pagination envelopes
      const data =
      candidates.find(
        (c) =>
        c &&
        typeof c === "object" &&
        !Array.isArray(c) && (
        c.firstName || c.lastName || c.email || c.empId || c.fullName)
      ) ||
      candidates.find((c) => c && typeof c === "object" && !Array.isArray(c)) ||
      {};

      if (!data || Object.keys(data).length === 0) return;

      setForm({
        firstName: data.firstName || '',
        middleName: data.middleName || '',
        lastName: data.lastName || '',
        dateOfBirth: data.dateOfBirth ? String(data.dateOfBirth).split("T")[0] : '',
        email: data.email || '',
        phone: data.phone || '',
        contactType: data.contactType || 'Phone',
        addressHouseNo: data.addressHouseNo || '',
        addressStreetName: data.addressStreetName || '',
        addressLocationArea: data.addressLocationArea || '',
        addressDistrict: data.addressDistrict || '',
        addressState: data.addressState || '',
        addressPincode: data.addressPincode || '',
        addressDigipin: data.addressDigipin || '',
        addressGmapLink: data.addressGmapLink || ''
      });

      setEmployeeIdentity({ empId: String(initialEmployeeId), name: getEmployeeName(data) });

      setSelectedStateId('');
    } catch (err) {
      console.error("Failed to load employee master info", err);
    }
  }, [initialEmployeeId, sessionAccessToken, tenantCodeFromSession, tenantId]);

  useEffect(() => {
    if (!isActive) return;
    if (!initialEmployeeId) {
      setForm(INITIAL);
      setEmployeeIdentity({ empId: "", name: "" });
      setSelectedStateId('');
      return;
    }
    fetchInfo();
  }, [isActive, initialEmployeeId, fetchInfo]);

  const fetchOrgLookup = useCallback(async (path) => {
    if (!tenantId) {
      throw new Error(i18n.t('onboarding.errors.tenantIdMissing'));
    }

    const requestPath = `${path}${path.includes('?') ? '&' : '?'}tenantId=${encodeURIComponent(String(tenantId))}`;
    const nextTenantId = String(tenantId || '').trim();
    const nextTenantCode = String(tenantCodeFromSession || '').trim();
    const nextAccessToken = String(sessionAccessToken || '').trim();
    const requestKey = `${requestPath}:${nextTenantCode}:${nextAccessToken}`;
    let request = orgLookupRequests.get(requestKey);
    if (!request) {
      request = (async () => {
        const response = await fetch(resolveOrgApiUrl(requestPath), {
          method: 'GET',
          headers: {
            Accept: '*/*',
            'x-service-code': 'HR20A',
            ...(nextAccessToken ? { Authorization: `Bearer ${nextAccessToken}` } : {}),
            ...(nextTenantId ? { 'X-Tenant-Id': nextTenantId } : {}),
            ...(nextTenantCode ? { 'X-Tenant-Code': nextTenantCode } : {})
          }
        });

        if (!response.ok) {
          const errorBody = await response.json().catch(() => null);
          const message = `Lookup request failed (${response.status})`;
          const error = new Error(message);
          error.status = response.status;
          error.errorBody = errorBody;
          throw error;
        }

        return response.json().catch(() => ({}));
      })();
      orgLookupRequests.set(requestKey, request);
    }
    return request;
  }, [sessionAccessToken, tenantCodeFromSession, tenantId]);

  /* ── Field change ─────────────────────────────────────── */
  const handleChange = useCallback((e) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
    const rules = getRules();
    if (touched[name] && rules[name]) {
      setErrors((er) => ({ ...er, [name]: rules[name](value) }));
    }
  }, [touched]);

  const handleBlur = useCallback((e) => {
    const { name, value } = e.target;
    setTouched((t) => ({ ...t, [name]: true }));
    const rules = getRules();
    if (rules[name]) {
      setErrors((er) => ({ ...er, [name]: rules[name](value) }));
    }
  }, []);

  const handleStateChange = useCallback((nextStateId) => {
    const selectedOption = stateOptions.find((option) => option.value === nextStateId);
    const rules = getRules();
    setSelectedStateId(nextStateId);
    setSelectedDistrictId('');
    setDistrictOptions([]);
    setForm((prev) => ({
      ...prev,
      addressState: selectedOption?.label || '',
      addressDistrict: ''
    }));
    setTouched((prev) => ({ ...prev, addressState: true, addressDistrict: false }));
    setErrors((prev) => ({
      ...prev,
      addressState: rules.addressState(selectedOption?.label || ''),
      addressDistrict: ''
    }));
  }, [stateOptions]);

  const handleDistrictChange = useCallback((nextDistrictId) => {
    const selectedOption = districtOptions.find((option) => option.value === nextDistrictId);
    const rules = getRules();
    setSelectedDistrictId(nextDistrictId);
    setForm((prev) => ({
      ...prev,
      addressDistrict: selectedOption?.label || ''
    }));
    setTouched((prev) => ({ ...prev, addressDistrict: true }));
    setErrors((prev) => ({
      ...prev,
      addressDistrict: rules.addressDistrict(selectedOption?.label || '')
    }));
  }, [districtOptions]);

  useEffect(() => {
    if (!isActive) return;
    let active = true;

    async function loadStates() {
      if (!tenantId) {
        if (active) {
          setStateOptions([]);
          setDistrictOptions([]);
        }
        return;
      }

      setStatesLoading(true);
      try {
        const data = await fetchOrgLookup(STATES_ENDPOINT);
        if (!active) return;
        setStateOptions(normalizeLookupOptions(data, ['stateId', 'id'], ['stateName', 'name']));
      } catch (error) {
        if (!active) return;
        setStateOptions([]);
        if (reportLookupRateLimit(error.message, error.status, error.errorBody)) return;
        setBanner((current) => current || { type: 'error', msg: error.message || i18n.t('onboarding.errors.unableToLoadStates') });
      } finally {
        if (active) setStatesLoading(false);
      }
    }

    loadStates();
    return () => {
      active = false;
    };
  }, [isActive, fetchOrgLookup, reportLookupRateLimit, tenantId]);

  useEffect(() => {
    if (!form.addressState.trim() || selectedStateId || stateOptions.length === 0) return;
    const match = stateOptions.find((option) => option.label.toLowerCase() === form.addressState.trim().toLowerCase());
    if (match) {
      setSelectedStateId(match.value);
    }
  }, [form.addressState, selectedStateId, stateOptions]);

  useEffect(() => {
    if (!isActive) return;
    let active = true;

    async function loadDistricts() {
      if (!tenantId || !selectedStateId) {
        if (active) {
          setDistrictOptions([]);
          setDistrictsLoading(false);
        }
        return;
      }

      setDistrictsLoading(true);
      try {
        const data = await fetchOrgLookup(`${DISTRICTS_BY_STATE_ENDPOINT}/${encodeURIComponent(selectedStateId)}`);
        if (!active) return;
        const options = normalizeLookupOptions(data, ['cityId', 'districtId', 'id'], ['cityName', 'districtName', 'name']);
        setDistrictOptions(options);
      } catch (error) {
        if (!active) return;
        setDistrictOptions([]);
        if (reportLookupRateLimit(error.message, error.status, error.errorBody)) return;
        setBanner((current) => current || { type: 'error', msg: error.message || i18n.t('onboarding.errors.unableToLoadDistricts') });
      } finally {
        if (active) setDistrictsLoading(false);
      }
    }

    loadDistricts();
    return () => {
      active = false;
    };
  }, [isActive, fetchOrgLookup, reportLookupRateLimit, selectedStateId, tenantId]);

  useEffect(() => {
    if (!form.addressDistrict.trim() || districtOptions.length === 0) return;
    const selected = districtOptions.find((option) => option.label.toLowerCase() === form.addressDistrict.trim().toLowerCase());
    setSelectedDistrictId(selected?.value || '');
  }, [districtOptions, form.addressDistrict]);

  /* ── Validate all ─────────────────────────────────────── */
  function validateAll() {
    const rules = getRules();
    const newErrors = {};
    let valid = true;
    Object.keys(rules).forEach((field) => {
      const msg = rules[field](form[field] || '');
      if (msg) {newErrors[field] = msg;valid = false;}
    });
    setErrors(newErrors);
    // Mark required fields and any fields with errors as touched so messages show
    const allTouched = {};
    REQUIRED_FIELDS.forEach((f) => {allTouched[f] = true;});
    Object.keys(newErrors).forEach((f) => { if (newErrors[f]) allTouched[f] = true; });
    setTouched(allTouched);
    return valid;
  }

  /* ── Submit ───────────────────────────────────────────── */
  async function handleSubmit() {
    setBanner(null);
    if (!validateAll()) {
      return;
    }

    setLoading(true);

    const payload = {
      firstName: form.firstName.trim(),
      middleName: isEdit ? form.middleName.trim() : form.middleName.trim() || undefined,
      lastName: form.lastName.trim(),
      dateOfBirth: form.dateOfBirth,
      email: isEdit ? form.email.trim() : form.email.trim() || undefined,
      phone: form.phone.trim(),
      contactType: form.contactType,
      addressHouseNo: form.addressHouseNo.trim(),
      addressStreetName: form.addressStreetName.trim(),
      addressLocationArea: form.addressLocationArea.trim(),
      addressDistrict: form.addressDistrict.trim(),
      addressState: form.addressState.trim(),
      addressPincode: form.addressPincode.trim(),
      addressDigipin: isEdit ? form.addressDigipin.trim() : form.addressDigipin.trim() || undefined,
      addressGmapLink: form.addressGmapLink.trim()
    };

    // Remove undefined keys (cleaner JSON body)
    Object.keys(payload).forEach((k) => payload[k] === undefined && delete payload[k]);

    const endpoint = isEdit ? `/saas/hrms/emp-info/update/${initialEmployeeId}` : API_ENDPOINT;
    const method = isEdit ? 'PUT' : 'POST';
    const serviceCode = isEdit ? 'HR01U' : SERVICE_CODE;

    try {
      const response = await fetch(resolveApiUrl(endpoint), {
        method: method,
        headers: {
          'Content-Type': 'application/json',
          'x-tenant-code': tenantCodeFromSession || '',
          'x-tenant-id': String(tenantId || ''),
          'x-service-code': serviceCode,
          'authorization': `Bearer ${sessionAccessToken}`
        },
        body: JSON.stringify(payload)
      });
      if (response.ok) {
        const data = await response.json().catch(() => ({}));
        const savedId = data?.employeeId || data?.empId || data?.data?.employeeId || data?.data?.empId || initialEmployeeId;
        if (savedId) {
          setEmployeeIdentity({ empId: String(savedId), name: getEmployeeName(form) });
        }

        setBanner({ type: 'success', msg: isEdit ? i18n.t('onboarding.errors.employeeUpdatedSuccessfully') : i18n.t('onboarding.errors.employeeAddedSuccessfully') });
        if (isEdit) {
          await fetchInfo();
        }
        setTimeout(() => {if (onSuccess) onSuccess(data);}, 1200);
      } else {
        const fieldLabels = getFieldLabels();
        const { errorMessage, errorBody } = await parseOnboardingErrorResponse(response, fieldLabels);
        handleOnboardingApiError(errorBody, errorMessage, { setErrors, setTouched, setBanner, fieldLabels });
      }
    } catch (err) {
      setBanner({ type: 'error', msg: i18n.t('onboarding.errors.couldNotReachServer') });
    } finally {
      setLoading(false);
    }
  }

  /* ── Shared input props ──────────────────────────────── */
  function inputProps(name, extra = {}) {
    return {
      id: name,
      name: name,
      value: form[name],
      onChange: handleChange,
      onBlur: handleBlur,
      className: `aep-input${errors[name] && touched[name] ? ' error' : ''}`,
      ...extra
    };
  }

  /* ── Render ──────────────────────────────────────────── */
  return (
    <div className={`aep-page${isTabMode ? ' is-tab-mode' : ''}`}>

      <main className="aep-main">
        {/* Breadcrumb */}
        {!isTabMode && breadcrumb &&
        <div className="aep-breadcrumb" aria-label={i18n.t("common.breadcrumb")}>
            {breadcrumb.map((item, i) =>
          <React.Fragment key={item.label}>
                {i > 0 && <span className="aep-bc-sep" aria-hidden="true">/</span>}
                <button
              className={`aep-bc-item${item.active ? ' active' : ''}`}
              onClick={item.active ? undefined : item.onClick}
              disabled={item.active}>

                  {item.label}
                </button>
              </React.Fragment>
          )}
          </div>
        }

        {!isTabMode &&
        <OnboardingPageTitle
          onBack={onBack}
          employeeId={employeeIdentity.empId}
          employeeName={employeeIdentity.name}
          titleClassName="aep-page-title"
          subtitleClassName="aep-page-sub"
          title={<Trans i18nKey="formActions.addEmployee" />}
          subtitle={<Trans i18nKey="onboarding.fillInTheDetailsToRegisterANew" />}
        />
        }

        <div className="aep-form-card">

          {/* ── Personal details ───────────────────────── */}
          <div className="aep-section">
            <p className="aep-section-title">
              <Trans i18nKey="onboarding.personalDetails" />
            </p>

            <div className="aep-grid cols-3">
              <Field id="firstName" label={i18n.t('onboarding.labels.firstName')} required error={touched.firstName && errors.firstName}>
                <input {...inputProps('firstName', { maxLength: 100, placeholder: i18n.t('onboarding.mandatory'), autoComplete: 'given-name' })} />
              </Field>

              <Field id="middleName" label={i18n.t('onboarding.labels.middleName')} error={touched.middleName && errors.middleName}>
                <input {...inputProps('middleName', { maxLength: 100, placeholder: i18n.t('common.optional') })} />
              </Field>

              <Field id="lastName" label={i18n.t('onboarding.labels.lastName')} required error={touched.lastName && errors.lastName}>
                <input {...inputProps('lastName', { maxLength: 100, placeholder: i18n.t('onboarding.mandatory'), autoComplete: 'family-name' })} />
              </Field>
            </div>

            <div className="aep-grid">
              <Field id="email" label={i18n.t('common.email')} required error={touched.email && errors.email}>
                <input {...inputProps('email', { type: 'email', maxLength: 150, placeholder: i18n.t('onboarding.mandatory'), autoComplete: 'email' })} />
              </Field>

              <Field id="phone" label={i18n.t('onboarding.labels.phoneNumber')} required error={touched.phone && errors.phone}>
                <input {...inputProps('phone', { type: 'tel', maxLength: 12, placeholder: i18n.t('onboarding.max12Digits'), autoComplete: 'tel' })} />
              </Field>
            </div>

            <div className="aep-grid">
              <Field id="contactType" label={i18n.t('onboarding.labels.preferredContact')} error={touched.contactType && errors.contactType}>
                <div className="aep-select-wrap">
                  <FormSelect
                    id="contactType"
                    name="contactType"
                    value={form.contactType}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className={`aep-select${errors.contactType && touched.contactType ? ' error' : ''}`}>

                    <option value=""><Trans i18nKey="onboarding.select" /></option>
                    <option value="Phone"><Trans i18nKey="common.phone" /></option>
                    <option value="Email"><Trans i18nKey="common.email" /></option>
                    <option value="Both"><Trans i18nKey="onboarding.both" /></option>
                  </FormSelect>
                </div>
              </Field>

              <Field id="dateOfBirth" label={i18n.t('onboarding.labels.dateOfBirth')} error={touched.dateOfBirth && errors.dateOfBirth}>
                <Popover>
                  <PopoverTrigger asChild>
                    <Button
                      type="button"
                      variant="outline"
                      className={`aep-input${errors.dateOfBirth && touched.dateOfBirth ? ' error' : ''} w-full h-auto justify-start text-left font-normal`}>

                      <CalendarIcon className="mr-2 h-4 w-4 per-file-hint" />
                      {form.dateOfBirth ?
                      format(new Date(form.dateOfBirth), 'PPP') :

                      <span className="text-muted-foreground"><Trans i18nKey="dateTime.pickADate" /></span>
                      }
                    </Button>
                  </PopoverTrigger>
                  <PopoverContent className="w-auto border-0 bg-transparent p-0 shadow-none" align="start">
                    <Calendar
                      mode="single"
                      selected={form.dateOfBirth ? new Date(form.dateOfBirth) : undefined}
                      disabled={{ after: new Date() }}
                      captionLayout="dropdown"
                      startMonth={new Date(1950, 0)}
                      endMonth={new Date()}
                      onSelect={(date) => {
                        if (!date) return;
                        const v = format(date, 'yyyy-MM-dd');
                        setForm((prev) => ({ ...prev, dateOfBirth: v }));
                        setTouched((prev) => ({ ...prev, dateOfBirth: true }));
                        setErrors((prev) => ({ ...prev, dateOfBirth: getRules().dateOfBirth(v) }));
                      }}
                      initialFocus
                      className="p-3 pointer-events-auto" />

                  </PopoverContent>
                </Popover>
              </Field>
            </div>

            <div className="aep-grid cols-3">
              <Field id="addressHouseNo" label={i18n.t('onboarding.labels.houseNo')} error={touched.addressHouseNo && errors.addressHouseNo}>
                <input {...inputProps('addressHouseNo', { maxLength: 50, placeholder: i18n.t('onboarding.houseNo') })} />
              </Field>

              <Field id="addressStreetName" label={i18n.t('onboarding.labels.streetName')} error={touched.addressStreetName && errors.addressStreetName}>
                <input {...inputProps('addressStreetName', { maxLength: 50, placeholder: i18n.t('onboarding.streetRoad') })} />
              </Field>

              <Field id="addressLocationArea" label={i18n.t('onboarding.labels.areaLocation')} error={touched.addressLocationArea && errors.addressLocationArea}>
                <input {...inputProps('addressLocationArea', { maxLength: 50, placeholder: i18n.t('onboarding.areaOrLocality') })} />
              </Field>
            </div>

            <div className="aep-grid cols-3">
              <Field id="addressState" label={i18n.t('onboarding.labels.state')} error={touched.addressState && errors.addressState}>
                <Select
                  value={selectedStateId}
                  onValueChange={handleStateChange}
                  disabled={statesLoading || stateOptions.length === 0}
                  onOpenChange={(open) => {
                    if (!open) {
                      setTouched((prev) => ({ ...prev, addressState: true }));
                      setErrors((prev) => ({ ...prev, addressState: getRules().addressState(form.addressState) }));
                    }
                  }}>

                  <SelectTrigger
                    id="addressState"
                    className={`aep-select${errors.addressState && touched.addressState ? ' error' : ''}`}>

                    <SelectValue placeholder={statesLoading ? i18n.t('onboarding.loadingStates') : stateOptions.length ? i18n.t('onboarding.selectState') : i18n.t('onboarding.noStatesAvailable')} />
                  </SelectTrigger>
                  <SelectContent>
                    {stateOptions.map((option) =>
                      <SelectItem key={option.value} value={option.value}>{option.label}</SelectItem>
                    )}
                  </SelectContent>
                </Select>
              </Field>

              <Field id="addressDistrict" label={i18n.t('onboarding.labels.district')} error={touched.addressDistrict && errors.addressDistrict}>
                <Select
                  value={selectedDistrictId}
                  onValueChange={handleDistrictChange}
                  disabled={!selectedStateId || districtsLoading || districtOptions.length === 0}
                  onOpenChange={(open) => {
                    if (!open) {
                      setTouched((prev) => ({ ...prev, addressDistrict: true }));
                      setErrors((prev) => ({ ...prev, addressDistrict: getRules().addressDistrict(form.addressDistrict) }));
                    }
                  }}>

                  <SelectTrigger
                    id="addressDistrict"
                    className={`aep-select${errors.addressDistrict && touched.addressDistrict ? ' error' : ''}`}>

                    <SelectValue
                      placeholder={
                      !selectedStateId ?
                      i18n.t('onboarding.selectStateFirst') :
                      districtsLoading ?
                      i18n.t('onboarding.loadingDistricts') :
                      districtOptions.length ?
                      i18n.t('onboarding.selectDistrict') :
                      i18n.t('onboarding.noDistrictsAvailable')
                      } />

                  </SelectTrigger>
                  <SelectContent>
                    {districtOptions.map((option) =>
                      <SelectItem key={option.value} value={option.value}>{option.label}</SelectItem>
                    )}
                  </SelectContent>
                </Select>
              </Field>

              <Field id="addressPincode" label={i18n.t('onboarding.labels.pincode')} error={touched.addressPincode && errors.addressPincode}>
                <input {...inputProps('addressPincode', { maxLength: 6, placeholder: i18n.t('onboarding.sixDigitCode'), inputMode: 'numeric', pattern: '[0-9]*' })} />
              </Field>
            </div>

            <div className="aep-grid">
              <Field id="addressDigipin" label={i18n.t('onboarding.labels.digipin')} error={touched.addressDigipin && errors.addressDigipin}>
                <input {...inputProps('addressDigipin', { maxLength: 10, placeholder: i18n.t('common.optional') })} />
              </Field>

              <Field id="addressGmapLink" label={i18n.t('onboarding.labels.googleMapsLink')} error={touched.addressGmapLink && errors.addressGmapLink}>
                <input {...inputProps('addressGmapLink', { type: 'url', placeholder: i18n.t('onboarding.googleMapsUrl') })} />
              </Field>
            </div>
          </div>

          {/* ── Submit ─────────────────────────────────── */}
          {banner &&
          <div className={`aep-banner ${banner.type}`} role="alert">
              {banner.msg}
            </div>
          }

          {!isTabMode &&
          <div className="aep-section">
              <button
              className="aep-submit-btn"
              type="button"
              onClick={handleSubmit}
              disabled={loading}>

                {loading ?
              <>{isEdit ? i18n.t('onboarding.updatingEmployee') : i18n.t('onboarding.addingEmployee')}</> :
              <>{isEdit ? i18n.t('onboarding.updateEmployee') : <Trans i18nKey="formActions.addEmployee" />}</>
              }
              </button>
            </div>
          }

        </div>
      </main>
    </div>);

}
